import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { nextStep, previousStep } from '../../store/onboarding/actions'

import backIcon from '../../assets/img/backIcon.png'
import nextIcon from '../../assets/img/nextIcon.png'
import { IFooterProps } from './types'
import { Plann3rStore } from '../../store/types'

const Footer: FC<IFooterProps> = ({ next }) => {
  const { step, steps } = useSelector((state: Plann3rStore) => state.onboarding)
  const dispatch = useDispatch()

  return (
    <div className="onboarding_footer">
      <button
        className="back"
        onClick={() => {
          dispatch(previousStep())
        }}
      >
        <img src={backIcon} alt="Back" />
        Back
      </button>
      <div className="bullets">
        {steps.map((s: string, index: number) => {
          if (index !== 0 && index !== steps.length - 1) {
            return (
              <div className={s === step ? 'bullet selected' : 'bullet'} />
            )
          }

          return <div key={ index } />
        }, this)}
      </div>
      <button
        className="next"
        onClick={() => {
          if (next) next()
          dispatch(nextStep())
        }}
      >
        Next
        <img src={nextIcon} alt="Next" />
      </button>
    </div>
  )
}

export default Footer
